module.exports = __webpack_public_path__ + "static/media/bob-martin.be241de1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/bob-martin.jpg
// module id = 192
// module chunks = 0